import { render, staticRenderFns } from "./ConfirmationGovernanceModal.vue?vue&type=template&id=2877b1a5&scoped=true&"
import script from "./ConfirmationGovernanceModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmationGovernanceModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationGovernanceModal.vue?vue&type=style&index=0&id=2877b1a5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2877b1a5",
  null
  
)

export default component.exports